<p-panel>
    <ng-container *ngIf="isReactiveFormReady; else reactiveFormLoadingState">
        <app-reactive-form-builder
            (afterSend)="onAfterSend()"
            (goBack)="goBack()"
            (internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
            (stableValueChanges)="stableValueChanges($event)"
            [form]="form.formFields"
            [getRequest]="getRequest"
            [id]="reactiveFormRecordId"
            [previousData]="initialPreviousData"
            [request]="request"
            [serverUrl]="form.env.serverUrl">
        </app-reactive-form-builder>
    </ng-container>
</p-panel>

<ng-template #reactiveFormLoadingState>
    <div class="p-3 text-center" role="status" aria-live="polite">
        <div *ngIf="!reactiveFormLoadingError" class="text-muted">
            Preparando formulario de edificios...
        </div>
        <div *ngIf="reactiveFormLoadingError" class="alert alert-danger mb-0" role="alert">
            {{ reactiveFormLoadingError }}
        </div>
    </div>
</ng-template>
